import { styles } from "@validereinc/common-components";

export const ChainOfCustodyStateIcons = {
  issued: { icon: "telegram", color: styles.status.warning },
  received: {
    icon: "check-circle",
    color: styles.legacy.statusCompletedColour,
  },
  removed: { icon: "times-circle", color: styles.status.error },
};
